const alphabeticallyAsc = (a: string, b: string) => a.localeCompare(b)
const numberAsc = (a: number, b: number) => (a > b ? 1 : -1)

export type ComparerCreator<RecordType = any> = (fieldName: keyof RecordType) => (a: RecordType, b: RecordType) => number
const createComparer: ComparerCreator = fieldName => (a, b) => a[fieldName] - b[fieldName]

export { alphabeticallyAsc, numberAsc, createComparer }
